import dayjs from "@/utils/dayjs";
import { store } from "@/store";

export const formatHistoryDate = (date: string, locale: string) => {
  if (locale === "ko") return dayjs(date).locale("ko").format("lll");
  if (locale === "en") dayjs(date).locale("en").format("lll");
  return dayjs(date).locale("en").format("lll");
};

const getShortTz = (timezone: string) => {
  return dayjs()
    .tz(timezone)
    .format("zzz")
    .replace(/[^A-Z]/g, "");
};

export const formatDate = (
  date: any,
  options: {
    timeZone?: string;
    format: string;
  },
) => {
  if (!date) return "";
  try {
    const dayIns = dayjs(date).locale(store.state.status.lang || "en");
    if (options.timeZone) {
      const isZone = options.format.includes("z");
      let formatted = dayIns
        .tz(options.timeZone)
        .format(options.format.replace("z", ""));
      if (isZone) formatted += getShortTz(options.timeZone);
      return formatted;
    }
    let dayString = dayIns.format(options.format);
    if (dayIns.locale() === "ko") {
      if (options.format === "L")
        dayString = dayString.replace(RegExp(/\.(?=[^.]*$)/), "");
    }
    return dayString;
  } catch (e) {
    console.error("formatDate", e, { date, options }); // 리포터로도
    return dayjs(date).format("YYYY-MM-DD HH:mm");
  }
};

export const convertToAllDay = (date: any) => {
  return dayjs(date).endOf("date");
};
